// extracted by mini-css-extract-plugin
export var confirmationHeader = "_x6-0";
export var confirmationIcon = "_x6-1";